// extracted by mini-css-extract-plugin
export default {"title":"alamat-email-pemilik-properti_title__6hWoz","input-wrapper":"alamat-email-pemilik-properti_input-wrapper__fU0ca","info":"alamat-email-pemilik-properti_info__qrOpa"};